// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13ajx","top":"styles_top__1E0cq"};